import React, { useState } from "react";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import Button from "@mui/material/Button";
import TextField from "@mui/material/TextField";
import Typography from "@mui/material/Typography";
import moment from "moment";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment";
import { StaticDatePicker } from "@mui/x-date-pickers/StaticDatePicker";

const styles = {
  dialogContent: {
    pt: 4,
    "& .MuiPickersCalendarHeader-root": {
      display: "none !important",
    },
    "& .MuiPickersCalendarHeader-label": {
      display: "none !important",
    },
    "& .MuiDateCalendar-header": {
      display: "none !important",
    },
  },
  staticDatePicker: {
    "& .MuiPickersCalendarHeader-root": {
      display: "none !important",
    },
    "& .MuiPickersCalendarHeader-label": {
      display: "none !important",
    },
    "& .MuiDateCalendar-header": {
      display: "none !important",
    },
  },
};

const DayPicker = ({ value, onChange, name }) => {
  const [open, setOpen] = useState(false);
  const [selectedDay, setSelectedDay] = useState(value ? parseInt(value) : null);

  const currentDate = moment().date(selectedDay || 1);

  const handleDateChange = date => {
    const day = moment(date).date();
    setSelectedDay(day);
    onChange(day.toString());
    setOpen(false);
  };

  return (
    <LocalizationProvider dateAdapter={AdapterMoment}>
      <TextField
        size="small"
        fullWidth
        label="Day of the Month"
        value={selectedDay ? selectedDay : ""}
        onClick={() => setOpen(true)}
        InputProps={{
          readOnly: true,
        }}
        placeholder="Select day"
      />

      <Dialog open={open} onClose={() => setOpen(false)} maxWidth="xs">
        <DialogTitle>
          <Typography color="text.primary" align="center">
            Select Day of Month
          </Typography>
        </DialogTitle>
        <DialogContent sx={styles.dialogContent}>
          <StaticDatePicker
            value={currentDate}
            onChange={handleDateChange}
            views={["day"]}
            sx={styles.staticDatePicker}
            slotProps={{
              actionBar: { actions: [] },
            }}
            slots={{
              calendarHeader: () => null,
            }}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpen(false)}>Cancel</Button>
        </DialogActions>
      </Dialog>
    </LocalizationProvider>
  );
};

export default DayPicker;
